import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  fas,
  faAngleDoubleUp

} from "@fortawesome/free-solid-svg-icons";

/*
 * Card marks, for the payment badge on Ordrer and Ordredetaljer.
 *
 * Named one by one rather than pulling in `fab` the way the solid set is pulled in as `fas`. The brands
 * package is the larger of the two and almost none of it is wanted here — importing the whole thing to
 * show a Visa mark would put every social-media logo in the bundle. These are exactly the cards Swedbank
 * Pay, Viva and Dintero can report.
 *
 * Not every brand has a mark: Maestro, Dankort, UnionPay and Vpay have none in Font Awesome, and they fall
 * back to the generic solid credit-card. That fallback is not a gap to be closed — a card nobody has a
 * logo for still needs to render.
 */
import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcApplePay,
  faGooglePay
} from "@fortawesome/free-brands-svg-icons";

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt, fas, faAngleDoubleUp,
  faCcVisa, faCcMastercard, faCcAmex, faCcDinersClub, faCcDiscover, faCcJcb, faCcApplePay, faGooglePay);

export { FontAwesomeIcon };
